"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMPTY_DRAFT_FIELD = void 0;
var EMPTY_DRAFT_FIELD = exports.EMPTY_DRAFT_FIELD = '<p><br></p>';